export enum BroadcastChannelName {
	TAB_COMMUNICATION = 'TAB_COMMUNICATION',
}

export enum BroadcastChannelEvent {
	LOGIN_COMPLETED = 'LOGIN_COMPLETED',
	SIGNUP_COMPLETED = 'SIGNUP_COMPLETED',
	WINDOW_CLOSED = 'WINDOW_CLOSED',
}
